/**
 * Reviewed-import operational RPC cohort (migration 144
 * `b2g_import_require_operational_actor`). Privileged configuration accounts
 * are excluded here and denied again by
 * `b2g_import_reject_privileged_configuration_actor`.
 *
 * Uses canonical `CASE_MANAGER` (not the invented `CLIENT_MANAGER` alias).
 */
export const REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES = Object.freeze([
  'COORDINATOR',
  'COMPLIANCE_OFFICER',
  'QUALITY_OFFICER',
  'CASE_MANAGER',
  'REGISTERED_NURSE',
] as const);

export type ReviewedImportOperationalSqlRole =
  (typeof REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES)[number];

/**
 * Waitlist is the P02 identity-conflict deep-link surface. Keep privileged
 * configuration accounts able to view the module for setup/ops, and admit the
 * operational import cohort so suggested assignees can open the controlled UI.
 */
export const WAITLIST_REVIEWED_IMPORT_ACCESS_ROLES = Object.freeze([
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  ...REVIEWED_IMPORT_OPERATIONAL_SQL_ROLES,
] as const);
